import { generateApiRoute } from '@klp/core/api/helpers';

const contractLeaseAgreementApiName = 'kontrakt';
const kundenummerApi = 'kundenummer';

export const contractLeaseAgreementApiRoutes = {
    list: (kundeNummer: string) =>
        generateApiRoute([
            contractLeaseAgreementApiName,
            kundenummerApi,
            kundeNummer,
        ]),
    download: (kundeNummer: string) =>
        generateApiRoute([
            contractLeaseAgreementApiName,
            'dokument',
            kundeNummer,
        ]),
};
